"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowController = void 0;
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var NavigationContainer_1 = __importDefault(require("./CreatePageComponents/NavigationContainer"));
var CreatePageTelemetry_1 = __importDefault(require("./CreatePageTelemetry"));
var inversify_react_1 = require("inversify-react");
var types_1 = require("CreatePageFlow/types");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var Types_1 = require("@CommonFrontendBackend/Account/Integrations/Types");
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var c = (0, BemBuilder_1.default)("create-page-flow");
exports.FlowController = (0, mobx_react_1.observer)(function (props) {
    var telemetry = (0, inversify_react_1.useInjection)(CreatePageTelemetry_1.default);
    var store = props.store, steps = props.steps, flowSource = props.flowSource;
    var _a = __read((0, react_1.useState)(0), 2), currentStep = _a[0], setCurrentStep = _a[1];
    var moveStep = function (direction) {
        var _a;
        telemetry.movedStep(steps[currentStep + direction].component.name, direction, store.templateId, (_a = store.template) === null || _a === void 0 ? void 0 : _a.crmInfo.integration, store.creatingPageError);
        setCurrentStep(currentStep + direction);
    };
    var selectedStep = steps[currentStep];
    var SelectedStepComponent = selectedStep.component;
    var resizeRef = (0, react_1.useRef)(null);
    var _b = __read((0, react_1.useState)({ width: 0, height: 0 }), 2), dimensions = _b[0], setDimensions = _b[1];
    (0, react_1.useEffect)(function () {
        fireAnimation();
    });
    var fireAnimation = function () {
        var _a, _b;
        if (ignoreIntegrationConfigModal()) {
            if (resizeRef.current) {
                var newWidth = (_a = resizeRef.current.childNodes[0]) === null || _a === void 0 ? void 0 : _a.offsetWidth;
                var newHeight = ((_b = resizeRef.current.childNodes[0]) === null || _b === void 0 ? void 0 : _b.offsetHeight) + (!selectedStep.excludeNavigation && 80);
                if (dimensions.width != newWidth || dimensions.height != newHeight) {
                    setDimensions({ width: newWidth, height: newHeight });
                }
            }
        }
    };
    var ignoreIntegrationConfigModal = function () {
        var _a, _b;
        return (!(((_a = store.integrationState) === null || _a === void 0 ? void 0 : _a.status) === Types_1.TokenIntegrationVerificationStatus.VERIFY_SUCCESS) ||
            (((_b = store.integrationState) === null || _b === void 0 ? void 0 : _b.status) === Types_1.TokenIntegrationVerificationStatus.VERIFY_SUCCESS && currentStep != 1));
    };
    var stepComponent;
    if (flowSource === types_1.CreatePageFlowSource.Crm) {
        stepComponent = (react_1.default.createElement(NavigationContainer_1.default, { steps: steps, currentStep: selectedStep, moveStep: moveStep, closeButtonHandler: props.closeButtonHandler },
            react_1.default.createElement(react_transition_group_1.TransitionGroup, { className: c("current-step") },
                react_1.default.createElement(react_transition_group_1.CSSTransition, { key: currentStep, timeout: kaleidoscope_1.AnimationDuration.ExtraLong, classNames: "fade" },
                    react_1.default.createElement("div", { ref: resizeRef, onLoad: fireAnimation },
                        react_1.default.createElement(SelectedStepComponent, { moveStep: moveStep, closeButtonHandler: props.closeButtonHandler, store: store, flowSource: flowSource }))))));
    }
    else {
        stepComponent = (react_1.default.createElement(NavigationContainer_1.default, { steps: steps, currentStep: selectedStep, moveStep: moveStep, closeButtonHandler: props.closeButtonHandler },
            react_1.default.createElement("div", { className: c("current-step") },
                react_1.default.createElement(SelectedStepComponent, { moveStep: moveStep, closeButtonHandler: props.closeButtonHandler, store: store, flowSource: flowSource }))));
    }
    return (react_1.default.createElement("div", { className: c(), style: flowSource == types_1.CreatePageFlowSource.Crm && dimensions.width && dimensions.height
            ? { width: "".concat(dimensions.width, "px"), height: "".concat(dimensions.height, "px") }
            : {} }, stepComponent));
});
exports.default = exports.FlowController;
